<ng-container *transloco="let t; read: 'home'">
  <div class="whatIsGap p-grid p-nogutter p-jc-center section-margin">
    <div class="p-grid p-nogutter p-jc-center whatIsGap__wrapper">
      <div class="p-col-12">
        <h2 class="home-heading textBlue p-text-center p-text-uppercase title">
          {{ t('whatIsGap.header1')
          }}<span class="textYellow">{{ t('whatIsGap.header2') }}</span>
        </h2>
        <div class="p-grid p-nogutter">
          <div class="p-sm-12 p-xl-4 whatIsGap__section">
            <div class="p-grid">
              <div class="p-col-12 whatIsGap__section__column">
                <div class="whatIsGap__section__header">
                  <span class="textYellow step-index">01</span>
                  <p class="textBlue">{{ t('whatIsGap.section1.header') }}</p>
                </div>
                <div class="whatIsGap__section__content">
                  <p [innerHTML]="t('whatIsGap.section1.content')"></p>
                </div>
              </div>
              <div class="p-sm-12 p-md-6 p-xl-12 whatIsGap__section__img">
                <img
                  class="circle-image"
                  src="assets/images/01_Mercedes_S.webp"
                  alt="s1-img"
                  loading="lazy"
                  decoding="async" width="640" height="640">
              </div>
            </div>
          </div>

          <div class="p-sm-12 p-xl-4 whatIsGap__section">
            <div class="p-grid">
              <div class="p-col-12 whatIsGap__section__column">
                <div class="whatIsGap__section__header">
                  <span class="textYellow step-index">02</span>
                  <p class="textBlue">{{ t('whatIsGap.section2.header') }}</p>
                </div>
                <div class="whatIsGap__section__content">
                  <p [innerHTML]="t('whatIsGap.section2.content1')"></p>
                </div>
              </div>
              <div class="p-sm-12 p-md-6 p-xl-12 whatIsGap__section__img">
                <img
                  class="circle-image"
                  src="assets/images/02_Zlodziej_auta.webp"
                  alt="s2-img"
                  loading="lazy"
                  decoding="async" width="640" height="640">
              </div>
            </div>
          </div>

          <div class="p-sm-12 p-xl-4 whatIsGap__section">
            <div class="p-grid">
              <div class="p-col-12 whatIsGap__section__column">
                <div class="whatIsGap__section__header">
                  <span class="textYellow step-index">03</span>
                  <p class="textBlue">{{ t('whatIsGap.section3.header') }}</p>
                </div>
                <div class="whatIsGap__section__content">
                  <p [innerHTML]="t('whatIsGap.section3.content')"></p>
                </div>
              </div>
              <div class="p-sm-12 p-md-6 p-xl-12 whatIsGap__section__img">
                <img
                  class="circle-image"
                  src="assets/images/03_Kierowca_samochodu.webp"
                  alt="s3-img"
                  loading="lazy"
                  decoding="async" width="640" height="640">
              </div>
            </div>
          </div>
        </div>

        <div class="p-grid p-nogutter whatIsGap__section paddingTop">
          <div
            class="p-d-none p-d-md-flex p-md-6 whatIsGap__section__img width50">
            <img
              class="imgBig"
              src="assets/images/suv-img.webp"
              alt="suv-img"
              loading="lazy"
              decoding="async" width="640" height="640">
            <img
              class="bgImg p-d-none p-d-xl-block"
              src="assets/images/bg1-img.svg"
              alt="tear"
              loading="lazy"
              decoding="async" width="1532" height="1026">
          </div>

          <div class="p-col-12 p-md-6 whatIsGap__section__gapHeader">
            <h2 class="home-heading textBlue p-text-normal">
              {{ t('whatIsGap.gap.header.1') }}
            </h2>
            <h2 class="home-heading textBlue">
              {{ t('whatIsGap.gap.header.2') }}
            </h2>
            <p class="textBlue p-text-bold">
              {{ t('whatIsGap.gap.header.4') }}
            </p>
            <div class="p-d-flex">
              <button
                type="button"
                class="buttonYellow p-my-2 p-mr-2 p-px-xl-2"
                (click)="scrollToBenefits()">
                {{ t('whatIsGap.gap.header.button') }}
              </button>
              <a
                class="buttonYellow p-d-none p-d-xl-inline-block p-my-2 p-px-xl-2"
                [href]="formUrl('/cta', 'ctaHeader')">
                <app-lock-open-icon></app-lock-open-icon>
                {{ t('tab.content.form.buy-gap') }}
              </a>
            </div>

            <div class="p-d-flex p-d-md-none whatIsGap__section__img">
              <img
                class="imgBig"
                src="assets/images/suv-img.webp"
                alt="suv-img"
                loading="lazy"
                decoding="async" width="640" height="640">
            </div>

            <div class="p-d-md-none p-d-xl-block">
              <p class="textBlue p-text-bold">
                {{ t('whatIsGap.gap.content.1') }}
              </p>
              <p [innerHTML]="t('whatIsGap.gap.content.2')"></p>
            </div>
          </div>
          <div class="p-d-none p-d-md-block p-md-12 p-d-xl-none">
            <p class="textBlue p-text-bold">
              {{ t('whatIsGap.gap.content.1') }}
            </p>
            <p [innerHTML]="t('whatIsGap.gap.content.2')"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
